import { render, staticRenderFns } from "./resovefun.vue?vue&type=template&id=69228e63&scoped=true&"
import script from "./resovefun.vue?vue&type=script&lang=js&"
export * from "./resovefun.vue?vue&type=script&lang=js&"
import style0 from "./resovefun.vue?vue&type=style&index=0&id=69228e63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69228e63",
  null
  
)

export default component.exports